import React from "react";
import clsx from "clsx";
import styles from "./Loader.module.scss";
export function Loader({ classStyle }) {
    return React.createElement("div", { className: clsx(styles.commonBlock, classStyle) });
}
